import jstz from 'jstz';
import Cookies from 'js-cookie';

Cookies.set('timezone', jstz.determine().name(), { secure: true });
